import EditOffIcon from "@mui/icons-material/EditOff";
import SaveIcon from "@mui/icons-material/Save";
import { Box, CircularProgress, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RequisitionFormType } from "../../../types/forms/warehouse/requisition";
import { EquipmentResponse } from "../../../types/model/warehouse/equipment";
import RequisitionForm from "./RequisitionForm";

interface NewRequisitionPanelProps {
  formId: string;
  isCreating: boolean;
  equipmentOptions: EquipmentResponse[];
  isLoadingEquipment?: boolean;
  onCancel: () => void;
  onSubmit: (values: RequisitionFormType) => Promise<void>;
}

export default function NewRequisitionPanel({
  formId,
  isCreating,
  equipmentOptions,
  isLoadingEquipment = false,
  onCancel,
  onSubmit,
}: Readonly<NewRequisitionPanelProps>) {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 3, m: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="subtitle1" fontWeight="medium">
          {t("warehouse.requisitions.add-new")}
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title={t("generic.cancel")}>
            <IconButton size="small" color="error" onClick={onCancel} disabled={isCreating}>
              <EditOffIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("generic.save")}>
            <IconButton size="small" color="success" type="submit" form={formId} disabled={isCreating}>
              {isCreating ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <RequisitionForm
        formId={formId}
        equipmentOptions={equipmentOptions}
        isLoadingEquipment={isLoadingEquipment}
        isSaving={isCreating}
        onSubmit={onSubmit}
      />
    </Paper>
  );
}